import { render, staticRenderFns } from "./timeoutTag.vue?vue&type=template&id=181258b1&scoped=true"
import script from "./timeoutTag.vue?vue&type=script&lang=js"
export * from "./timeoutTag.vue?vue&type=script&lang=js"
import style0 from "./timeoutTag.vue?vue&type=style&index=0&id=181258b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181258b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181258b1')) {
      api.createRecord('181258b1', component.options)
    } else {
      api.reload('181258b1', component.options)
    }
    module.hot.accept("./timeoutTag.vue?vue&type=template&id=181258b1&scoped=true", function () {
      api.rerender('181258b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/components/timeoutTag.vue"
export default component.exports